<template>
	<div>
		<b-navbar fixed="top" variant="white" class="shadow">
			<div class="container">
				<b-navbar-brand :to="{ name: 'components' }">
					<img
						:src="require('@/assets/img/logo.jpg')"
						alt="Mobil"
						class="img-fluid"
						style="height: auto; width: 100%; max-width: 150px"
					/>
				</b-navbar-brand>
			</div>
		</b-navbar>
		<div
			class="container mt-4 text-dark"
			style="padding-top: 80px; padding-bottom: 50px"
		>
			<h4 class="text-dark">PUBLICACIÓN DE GANADORES:</h4>
			<p>
				El nombre de los ganadores se dar&aacute; a conocer el&nbsp;
				<strong>27 de octubre del 2021</strong>, a trav&eacute;s de las redes
				sociales de MOBIL<sup>™</sup>, sus clientes y proveedores.
			</p>
			<h4 class="text-dark">ENTREGA DE PREMIOS:</h4>
			<p>
				Los premios se entregarán a partir del 
				<strong>29 de octubre del 2021</strong> en las estaciones de servicio MOBIL<sup>™</sup> donde resulten los ganadores.
			</p>
		</div>
		<FooterBack></FooterBack>
	</div>
</template>
<script>
import FooterBack from "./components/FooterBack";
export default {
	name: "ganadores",
	components: {
		FooterBack,
	},
};
</script>
